(function () {
  function initFeaturedCollectionsSlider() {
    console.log("initFeaturedCollectionsSlider");
    const sliderEls = document.querySelectorAll(".featured-collections-slider");

    if (typeof BlazeSlider === "undefined") {
      setTimeout(initFeaturedCollectionsSlider, 100);
      return;
    }

    sliderEls.forEach(function (sliderEl) {
      if (sliderEl.blazeSlider) {
        return;
      }

      // Obter gap configurado do data-attribute ou usar padrão
      const itemGap = sliderEl.getAttribute('data-item-gap') || '8';
      const slideGap = itemGap + 'px';

      try {
        new BlazeSlider(sliderEl, {
          all: {
            slidesToShow: 7,
            slidesToScroll: 1,
            loop: false,
            enableAutoplay: false,
            transitionDuration: 400,
            transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
            slideGap: slideGap,
          },
          "(max-width: 1400px)": {
            slidesToShow: 6,
          },
          "(max-width: 1200px)": {
            slidesToShow: 5,
          },
          "(max-width: 900px)": {
            slidesToShow: 4,
          },
          "(max-width: 700px)": {
            slidesToShow: 2.5,
            slideGap: slideGap,
          },
          "(max-width: 500px)": {
            slidesToShow: 2,
            slideGap: slideGap,
          },
          "(max-width: 400px)": {
            slidesToShow: 1.8,
            slideGap: slideGap,
          },
        });
      } catch (error) {
        console.error("Error initializing BlazeSlider:", error);
      }
    });
  }

  function waitForBlazeSlider() {
    if (typeof BlazeSlider !== "undefined") {
      initFeaturedCollectionsSlider();
    } else {
      setTimeout(waitForBlazeSlider, 50);
    }
  }

  function init() {
    waitForBlazeSlider();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
